/**
 * Convert a File object to base64 string
 * @param {File} file - The file to convert
 * @returns {Promise<string>} Base64 string of the file
 */
export const fileToBase64 = async (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]);
    reader.readAsDataURL(file);
  });
};

/**
 * Process attachment for API submission
 * @param {Object} attachment - The attachment object
 * @returns {Promise<Object>} Processed attachment with type, contentType and base64 content
 */
export const processAttachment = async (attachment) => {
  if (attachment.type === 'image' && attachment.file) {
    const base64Data = await fileToBase64(attachment.file);
    return {
      type: attachment.type,
      contentType: attachment.file.type,
      content: base64Data
    };
  }
  return attachment;
};

/**
 * Validate image file
 * @param {File} file - The file to validate
 * @param {number} maxSize - Maximum file size in bytes
 * @returns {boolean} Whether the file is valid
 */
export const validateImageFile = (file, maxSize = 5 * 1024 * 1024) => {
  if (!file.type.startsWith('image/')) {
    console.error('Invalid file type:', file.type);
    return false;
  }
  if (file.size > maxSize) {
    console.error('File too large:', file.size);
    return false;
  }
  return true;
};